import React from 'react';
import { Modal } from 'antd';
import { Button, Form } from '@blueprintnyc/bpnyc-common';
import GroupSelector from 'components/GroupSelector';
import './LibraryCreateDialog.scss';

const LibraryCreateDialog = props => {
	const { visible, onCreate, event, from, onCancel } = props;

	const handleOnCreate = values => {
		onCreate(values);
	};

	return (
		<Modal
			className={'LibraryCreateModal'}
			title="Create a new library"
			open={visible}
			onCancel={onCancel}
			footer={null}
		>
			<Form onFinish={handleOnCreate} initialValues={{ name: '', groups: [] }}>
				<Form.Item
					label="Name"
					name="name"
					rules={[{ required: true, message: 'Please give your library a name.' }]}
				>
					<Form.Input />
				</Form.Item>
				{from === 'AttendeeMaterial' ? (
					<Form.Item label="Groups" name="groups">
						<GroupSelector event={event} />
					</Form.Item>
				) : null}
				<div className="formCancelSubmitButtonDiv">
					<Button onClick={onCancel} ghost={true}>
						Cancel
					</Button>
					<Button type="primary" htmlType="submit">
						OK
					</Button>
				</div>
			</Form>
		</Modal>
	);
};

export default LibraryCreateDialog;
